import { useLocation } from 'react-router-dom';

import { GridContainer, Headline } from 'libs/ui';
import { Content } from './soupload.styled';
import { Menu } from './menu';
import { Uploader } from './uploader';

export const SOUpload = () => {
  const location = useLocation();
  const isClients = location.pathname.indexOf('/clients') !== -1;
  const isDiscounts = location.pathname.indexOf('/discounts') !== -1;
  const type = isClients ? 'clients' : isDiscounts ? 'discounts' : 'so';

  return (
    <GridContainer>
      <Content>
        <Headline $mb>Загрузка СО</Headline>
        <Menu />
      </Content>

      <Uploader type={type} />
    </GridContainer>
  );
};

export default SOUpload;
